import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { taskService } from './task.service';
import { laborService } from '../labor/labor.service';
import {
  GET_TASKS, GET_TASKS_SUCCESS,
  GET_TASK, GET_TASK_SUCCESS,
  CREATE_TASK, CREATE_TASK_SUCCESS,
  EDIT_TASK, EDIT_TASK_SUCCESS,
  DELETE_TASK, DELETE_TASK_SUCCESS,
  UPDATE_TASK_STATUS, UPDATE_TASK_STATUS_SUCCESS,
} from './task.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getTasksSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(taskService.getTasks, payload);
    yield put({ type: GET_TASKS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* getTaskSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(taskService.getTask, payload);
    yield put({ type: GET_TASK_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createTaskSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const { pendingLabor, ...taskData } = payload;
    const res = yield call(taskService.createTask, taskData);
    yield put({ type: CREATE_TASK_SUCCESS, payload: res.data });
    // Create any pending labor entries
    if (pendingLabor && pendingLabor.length > 0) {
      for (const labor of pendingLabor) {
        try {
          yield call(laborService.createLabor, { ...labor, task: res.data._id });
        } catch (e) { /* ignore individual labor errors */ }
      }
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* editTaskSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(taskService.editTask, payload.id, payload.data);
    yield put({ type: EDIT_TASK_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* deleteTaskSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    yield call(taskService.deleteTask, payload);
    yield put({ type: DELETE_TASK_SUCCESS, payload });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* updateTaskStatusSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(taskService.updateTaskStatus, payload.id, payload.status);
    yield put({ type: UPDATE_TASK_STATUS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchTasks() {
  yield takeLatest(GET_TASKS, getTasksSaga);
  yield takeLatest(GET_TASK, getTaskSaga);
  yield takeLatest(CREATE_TASK, createTaskSaga);
  yield takeEvery(EDIT_TASK, editTaskSaga);
  yield takeLatest(DELETE_TASK, deleteTaskSaga);
  yield takeEvery(UPDATE_TASK_STATUS, updateTaskStatusSaga);
}
